<template>
  <div class="">
    <div class="row" v-if="isLoading">
      <div class="col">
        Loading...
      </div>
    </div>
    <div class="row" v-if="!isLoading">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-header">
            Company
            <br/>
            <small>Here you add relevant information from your client</small>
            <a href="#" class="create" data-toggle="modal" @click.prevent="showCompanyModal(-1)">+ Add
              company</a>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <model-list-select :list="companies" v-model="selectedCompany" option-value="id"
                                   option-text="name"
                                   placeholder="Select company"
                                   v-if="companies.length > 0">
                </model-list-select>
              </div>

            </div>
            <div class="mt-3 text-right" v-if="selectedCompany !== undefined">
              <a href="#" class="edit btn btn-outline-primary btn-sm btn-xs text-readable" data-toggle="modal"
                 @click.prevent="showCompanyModal(selectedCompany)">
                Edit Company
              </a>
            </div>
            <CompanyEditorModal ref="companyModal" @interface="companyUpdated" :company="editCompany"/>
          </div>
        </div>

        <div class="card" v-if="currentInvoice">
          <div class="card-header">
            Your invoice
            <br/>
            <small>Here you add relevant information for the work done</small>
            <a href="#" class="create" @click.prevent="newInvoiceRow">+ Add info</a>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped create-invoice">
                <tr>
                  <th style="width:auto;">Item</th>
                  <th style="width:60px;">Amount</th>
                  <th style="width:100px;">Price per unit</th>
                  <th style="width:60px;">Netto</th>
                  <th style="width:40px;">VAT</th>
                  <th style="width:60px;">Total</th>
                  <th style="width:40px;"></th>
                  <th style="width:50px;"></th>
                </tr>
                <tbody>
                <tr v-for="row in currentInvoice.rows" :key="row.id">
                  <td>{{ row.name }}</td>
                  <td>{{ rowCount(row) }}</td>
                  <td>{{ row.price | formatCurrency(currentInvoice.currency) }}</td>
                  <td>{{ row.amount | formatCurrency(currentInvoice.currency) }}</td>
                  <td>{{ row.vat }}%</td>
                  <td>{{
                      getNetto(row.amount, row.vat) + row.amount |
                          formatCurrency(currentInvoice.currency)
                    }}
                  </td>
                  <td class="text-right">
                    <a href="#" class="text-primary" @click="editInvoiceRow(row)">Edit</a>
                  </td>
                  <td class="text-right">
                    <a href="#" class="text-warning" @click="removeInvoiceRow(row)">Remove</a>
                  </td>
                </tr>
                <tr>
                  <th colspan="3">Sum:</th>
                  <th>{{ netto | formatCurrency(currentInvoice.currency) }}</th>
                  <td></td>
                  <th>{{ brutto | formatCurrency(currentInvoice.currency) }}</th>
                  <td colspan="2"></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="modal fade" id="invoiceRowModal" tabindex="-1" role="dialog"
                 aria-labelledby="invoiceRowModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="invoiceRowModalLabel">Work done</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <invoice-row-editor :invoice="currentInvoice" :invoice-row="invoiceRow"
                                        :units="units" :nationality="nationality"
                                        @interface="onInvoiceRowChange"></invoice-row-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="currentInvoice">
          <div class="card-header">
            Invoice settings
            <br/>
            <small>Modify invoice settings</small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <auto-input label="Purchase Order" v-model="currentInvoice.purchase_order"
                            field_name="purchase_order"
                            :route="getUpdateRoute"></auto-input>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <auto-input label="Specification" v-model="currentInvoice.specification"
                            field_name="specification"
                            :route="getUpdateRoute" type="textarea"></auto-input>
              </div>
            </div>
            <div>
              <div class="form-group">
                <label for="formControlSelectCurrency">Currency</label>
                <select id="formControlSelectCurrency" class="form-control" v-model="selectedCurrency">
                  <option v-for="currencyOption in currencyOptions" :value="currencyOption">
                    {{ currencyOption }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="formControlSelectOccupation">Occupation</label>
                <select id="formControlSelectOccupation" placeholder="" class="form-control"
                        v-model="selectedOccupation">
                  <option value="" disabled>Select an occupation</option>
                  <option v-for="occupation in occupations" :value="occupation.id">
                    {{ occupation.title }}
                  </option>
                </select>
              </div>
              <div class="form-group" v-if="hasTaxRate">
                <label for="formControlSelectTax">Tax rate (%)</label>
                <input data-toggle="tooltip" data-placement="top"
                       title="You can edit your tax-rate in your account settings" type="text"
                       id="formControlSelectTax" v-model="tax" placeholder="None" class="form-control"
                       disabled>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="currentInvoice">
        <invoice-summary :invoice="currentInvoice" :company="currentCompany" :employeeFee="employeeFee" :quickPayFee="quickPayFee" :useQuickPay="useQuickPay">
          <div class="form-check invoice d-flex align-items-center" @click.prevent="useQuickPay = !useQuickPay">
            <div class="checkbox-container" :class="{ active: useQuickPay }">
              <i class="material-icons">check</i>
            </div>
            <label for="requestQuickPay" class="form-check-label" style="user-select: none">
              <div>Request Quick Pay</div>
              <div class="text-readable small">
                Request a quicker payout for an additional <strong>{{ this.quickPayFee }} %</strong> fee if approved by Charge.<br>
              </div>
            </label>
            <input type="checkbox" id="requestQuickPay" class="form-check-input" v-model="useQuickPay">
          </div>
          <hr>
          <fieldset class="border p-2">
            <legend class="w-auto">Required</legend>
            <dl>
              <dd v-html="requirePersonalInfo"></dd>
              <dd v-html="requireBankInfo"></dd>
              <dd v-html="requireAccept"></dd>
              <dd v-html="requireInfo"></dd>
              <dd v-html="requireCompany"></dd>
              <dd v-html="requireOccupation"></dd>
            </dl>
          </fieldset>
          <hr>
          <accept-terms type="invoice" :nationality="nationality" title="Egenanställningsavtal" version="0.0.1" condition="Terms"
                        v-model="acceptedTerms">
            <p>ANSTÄLLNINGSAVTAL EGENANSTÄLLD</p>
            <p>Detta anställningsavtal (“<b>Avtalet</b>”) har träffats mellan Charge och den Egenanställde
              (definierade nedan) (var och en ”<b>Part</b>” och gemensamt ”<b>Parterna</b>”).</p>
            <p>UPPGIFTER OM ANSTÄLLNINGEN</p>

            <p><b>Arbetsgivare</b>: Charge AB, 559173-9510, c/o Tourn International AB, Stureplan 2 114 35
              Stockholm (”<b>Charge</b>”)</p>
            <p><b>Arbetstagare</b>: Personuppgifter framgår av det personliga kontot på Chargeplattformen
              (den ”<b>Egenanställde</b>”)</p>

            <p>Detta Avtal består av detta huvudavtal samt de allmänna villkoren för anställningen som
              framgår av Bilaga 1: Allmänna Villkor för Egenanställd. Charge kan, utöver Avtalet med
              bilagor, komma att tillhandahålla ytterligare policys och regler, vilka i så fall ska läsas
              tillsammans med detta Avtal. Vid motstridiga bestämmelser gäller detta Avtal (inklusive
              bilagor) före eventuella andra policys och regler som Charge tillhandahåller.</p>
            <p>Detta avtal undertecknas elektroniskt av den Egenanställde genom verifikation med BankID på
              den Egenanställdes personliga konto på Charges plattform på www.charge.gg (”<b>Chargeplattformen</b>”).
            </p>
            <p>Genom att underteckna Avtalet bekräftar den Egenanställde att han/hon läst och förstått detta
              Avtal samt Bilaga 1: Allmänna Villkor för Egenanställd; Bilaga 2: Allmänna Villkor för Kund
              samt eventuella andra policys och regler som Charge tillhandahåller.</p>
            <p>Bindande avtal uppstår först efter att Charge godkänt anställningsavtalet och Uppdraget
              (definieras nedan), vilket ska ske separat vid varje anställningstillfälle.</p>
            <p><strong>Anställningsavtal accepteras aldrig för tid då den Egenanställde har varit anställd
              hos Charge i allmän visstidsanställning i sammanlagt mer än två år under en
              femårsperiod.</strong></p>
            <p>1. Befattning</p>
            <p>1.1 Den Egenanställde anställs härmed hos Charge på den befattning som framgår av den
              Egenanställdes personliga konto Chargeplattformen.</p>
            <p>1.2 Detta Avtal ersätter samtliga tidigare såväl skriftliga som muntliga avtal om anställning
              och anställningsförmåner mellan Charge och den Egenanställde.</p>
            <p>1.3 Den Egenanställde försäkrar att han/hon från tillträdesdagen inte är underkastad några
              restriktioner från tidigare arbetsgivare eller annan – t.ex. till följd av tillämplig
              lagstiftning såsom lagen (2018:558) om företagshemligheter – som kan påverka den
              Egenanställdes möjligheter att fullgöra sitt arbete för Charge. Vidare är den Egenanställde
              medveten om att han/hon i sin anställning hos Charge inte har rätt att använda sig av eller
              avslöja företagshemligheter eller annan sekretessbelagd information från tidigare
              arbetsgivare eller annan.</p>
            <p>2. Anställningsform och tillträde</p>
            <p>2.1 Den Egenanställde anställs i en allmän visstidsanställning i enlighet med 5 § i lagen om
              anställningsskydd (1982:80).</p>
            <p>2.2 Anställningen gäller endast för tidsperiod då den Egenanställde utför uppdrag åt
              <b>kund</b> (”<b>Uppdrag</b>”), dock maximalt 30 dagar. Uppdraget framgår av
              uppdragsbeskrivningen för varje enskilt Uppdrag som från tid till annan finns på den
              Egenanställdes personliga konto på Chargeplattformen</p>
            <p>2.3 Tillträdesdag framgår av den Egenanställdes personliga konto på Chargeplattformen.</p>
            <p>3. Arbetsuppgifter m.m.</p>
            <p>Den Egenanställdes arbetsuppgifter av framgår av uppdragsbeskrivningen för varje enskilt
              Uppdrag som från tid till annan finns på den Egenanställdes personliga konto på
              Chargeplattformen.</p>
            <p>4. Arbetsplats</p>
            <p>Den Egenanställde ska utföra sina arbetsuppgifter på den plats som krävs med beaktande av
              Uppdraget.</p>
            <p>5. Arbetstid</p>
            <p>5.1 Arbetstiden framgår av uppdragsbeskrivningen för varje enskilt Uppdrag som från tid till
              annan finns på den Egenanställdes personliga konto på Chargeplattformen.</p>
            <p>5.2 Den Egenanställde kontrollerar sin arbetstid själv. Den Egenanställde åtar sig att aldrig
              utföra arbete i strid med Arbetstidslagen (1982:673).</p>
            <p>6. Lön och förmåner</p>
            <p>6.1 Den Egenanställde uppbär lön i enlighet med de Uppdrag som utförs för och faktureras till
              kund.</p>
            <p>6.2 Lön utbetalas i efterhand, senast [antal] dagar efter att Charge erhållit ersättning för
              utfört Uppdrag. Den Egenanställde är medveten om att betalning kan bli fördröjd, för det
              fall slut kund ej betalar sker utbetalning först efter att inkassoförfarande utförts.</p>
            <p>6.3 Har den Egenanställde ej Uppdrag eller om ett Uppdrag ej genererar någon intäkt så finns
              ingen lön att betala ut till den Egenanställde.</p>
            <p>6.4 Eventuella förmåner som inte uttryckligen anges i detta Avtal, men som under
              anställningen faktiskt tillhandahålls den Egenanställde, får återkallas av Charge med
              omedelbar verkan utan skyldighet att kompensera den Egenanställde.</p>
            <p>7. Arbetsredskap</p>
            <p>För utförande av den Egenanställdes arbetsuppgifter tillhandahåller den Egenanställdes själv
              sådan utrustning som är väsentlig för arbetets utförande. I vissa fall kan Charges kunder
              komma att tillhandahålla arbetsredskap för den Egenanställde.</p>
            <p>8. Försäkring</p>
            <p>8.1 Den Egenanställde omfattats av Trygghetsförsäkring vid arbetsskada (TFA) och
              Tjänstegrupplivförsäkring (TGL).</p>
            <p>8.2 En förutsättning för att omfattas av försäkringarna är att den Egenanställde är fullt
              frisk och arbetsför samt har föranmält sina Uppdrag till Charge och fått dessa godkända.</p>
            <p>8.3 Vissa typer av branscher och Uppdrag kräver att en eller flera tilläggsförsäkringar
              tecknas. Det åligger den Egenanställde att själv teckna och bekosta adekvat
              tilläggsförsäkring innan viss typ av Uppdrag kan påbörjas.</p>
            <p>9. Semester</p>
            <p>9.1 Semester utgår i enlighet med semesterlagen (1977:480).</p>
            <p>9.2 Då anställningen kan pågå i högst 30 dagar ska semesterledighet inte ska läggas ut. Den
              Egenanställde har istället rätt till semesterersättning. Semesterersättningen utgör tolv
              procent av den Egenanställdes förfallna lön.</p>
            <p>10. Sekretess</p>
            <p>10.1 Den Egenanställde förbinder sig att utan begränsning i tiden, d.v.s. även för tiden
              efter anställningens upphörande, inte för tredje man avslöja eller för egen räkning
              utnyttja, vare sig direkt eller indirekt, konfidentiell information hänförlig till Charge
              eller dess koncernbolag. Den Egenanställde förbinder sig vidare att förvara konfidentiell
              information under former som är tillfredställande med hänsyn till detta sekretesskrav och
              som skyddar informationen från obehörig åtkomst eller förändring.</p>
            <p>10.2 Med ”konfidentiell information” förstås företagshemligheter samt varje uppgift (teknisk,
              kommersiell eller av annan art) – oavsett om uppgiften har dokumenterats eller inte och
              oavsett om upplysningen är skriftligt eller muntlig – hänförlig till Charge, dess
              verksamhet, kunder, leverantörer eller samarbetspartners eller hänförlig till eventuella
              koncernbolag, dessa bolags verksamhet, kunder, leverantörer eller samarbetspartners. Som
              konfidentiell information räknas således bl.a.:</p>
            <p>(a) information om Charges produkter eller tjänster;</p>
            <p>(b) kundregister och annan information om eller hänförlig till kunder/potentiella kunder;</p>
            <p>(c) information om eller hänförlig till leverantörer/potentiella leverantörer; och</p>
            <p>(d) marknadsplaner, kostnadsanalyser och intäktsanalyser.</p>
            <p>Uppräkningen ovan är inte uttömmande utan endast exemplifierade.</p>
            <p>10.3 Med ”konfidentiell information” avses dock inte information som är eller blir allmänt
              känd på annat sätt än p.g.a. brott mot detta Avtal.</p>
            <p>11. Personuppgifter</p>
            <p>Den Egenanställde bekräftar att Charge i enlighet med den allmänna dataskyddsförordningen
              (Förordning (EU) nr 2016/679 (GDPR) informerat den Egenanställde om Charges behandling av
              anställdas personuppgifter.</p>
            <p>12. Avtalets giltighet</p>
            <p>Avtalet gäller från och med att Charge godkänt den Egenanställdes Uppdrag och löper till dess
              att Uppdraget avslutats, dock maximalt i 30 dagar. Eventuella ändringar av
              uppdragsbeskrivningen för Uppdraget måste skriftligen godkännas av Charge.</p>
            <p>13. Avtalsbrott</p>
            <p>Om den Egenanställde åsidosätter sina skyldigheter enligt detta Avtal eller på annat sätt
              åsidosätter sina skyldigheter i anställningsförhållandet har Charge rätt att med omedelbar
              verkan häva avtalet. Vid hävning förlorar den Egenanställde all rätt till lön och andra
              anställningsförmåner. Den Egenanställdes skyldigheter enligt punkt 10 (Sekretess) och enligt
              bestämmelserna om immateriella rättigheter i de Allmänna Villkoren för Egenanställda ska
              dock kvarstå.</p>
            <p>14. Övriga bestämmelser</p>
            <p>Ändringar och tillägg till detta Avtal ska för att vara bindande vara skriftliga.</p>
            <p>15. Tillämplig lag och tvist</p>
            <p>Svensk rätt är tillämplig på detta Avtal. Tvist i anledning av detta avtal ska slutligt
              avgöras genom allmän domstol.</p>
          </accept-terms>
          <div class="mb-1">
            <button href="#" class="btn btn-primary btn-block" data-toggle="modal"
                    data-target="#invoiceValidateModal" :disabled="!invoiceDone">
              {{ 'invoice.verifyAndCreate'| lang }}
            </button>
          </div>

          <div class="modal fade" id="invoiceValidateModal" tabindex="-1" role="dialog"
               aria-labelledby="invoiceRowModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="invoiceValidateModalLabel">{{
                      'invoice.validateBefore.title' | lang
                    }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="container-fluid" v-if="invoiceDone">
                    <div class="row">
                      <div class="col-sm-12">
                        <table class="table companyInformation">
                          <tbody>
                          <tr v-show="currentInvoice.purchase_order">
                            <th colspan="2" style="line-height: 30px;">Purchase Order:
                              {{ currentInvoice.purchase_order }}
                            </th>
                          </tr>
                          <tr>
                            <td><b>{{ currentCompany.name }}</b></td>
                            <td class="text-right">{{ currentCompany.address_line_1 }},
                              {{
                                currentCompany.address_line_2
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ currentCompany.organization_number }}</td>
                            <td class="text-right">{{ currentCompany.zip_code }}, {{
                                currentCompany.city
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ currentCompany.vat_number }}</td>
                            <td class="text-right">{{ currentCompany.country }}</td>
                          </tr>
                          <tr>
                            <td>{{ currentCompany.contact_person }}</td>
                            <td class="text-right"></td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td colspan="2">

                              <table class="table table-striped create-invoice">
                                <tbody>
                                <tr>
                                  <th>Entity</th>
                                  <th>Netto</th>
                                  <th>VAT</th>
                                  <th>Total</th>
                                </tr>
                                <tr v-for="row in currentInvoice.rows"
                                    :key="row.id">
                                  <td>{{ row.name }}</td>
                                  <td>{{
                                      row.amount |
                                          formatCurrency(currentInvoice.currency)
                                    }}
                                  </td>
                                  <td>{{ row.vat }}%</td>
                                  <td>{{
                                      getNetto(row.amount, row.vat) +
                                      row.amount |
                                          formatCurrency(currentInvoice.currency)
                                    }}
                                  </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                  <th></th>
                                  <th>{{
                                      netto |
                                          formatCurrency(currentInvoice.currency)
                                    }}
                                  </th>
                                  <th>{{
                                      vat |
                                          formatCurrency(currentInvoice.currency)
                                    }}
                                  </th>
                                  <th>{{
                                      brutto |
                                          formatCurrency(currentInvoice.currency)
                                    }}
                                  </th>
                                </tr>
                                </tfoot>
                              </table>

                            </td>
                          <tr>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary btn-block"
                          :disabled="(currentInvoice.rows.length <= 0 || locked || updating)" v-on:click="sendInvoice">
                    Verify and Create Invoice
                  </button>
                </div>
              </div>
            </div>
          </div>
        </invoice-summary>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-search-select/dist/VueSearchSelect.css';
import {ModelListSelect} from 'vue-search-select';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    nationality: {
      type: String,
      required: true,
    },
    preferredCurrency: {
      type: String,
      default: 'SEK',
      required: false,
    },
    invoice: {
      type: Object,
      required: false,
    },
    units: {
      type: Array,
      required: true,
    },
    employeeFee: {
      type: Number,
      required: true,
    },
    quickPayFee: {
      type: Number,
      required: true,
    },
    occupations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      locked: false,
      updating: false,
      updateQueueId: 0,
      loaded: false,
      currentInvoice: undefined,
      companies: [],
      selectedCompany: undefined,
      currencyOptions: ['SEK', 'USD', 'EUR'],
      selectedCurrency: this.preferredCurrency || 'SEK',
      selectedOccupation: '',
      tax: 30,
      acceptedTerms: false,
      invoiceRow: undefined,
      editCompany: {},
      useQuickPay: false,
    };
  },
  computed: {
    hasTaxRate() {
      return this.nationality === 'SE';
    },
    invoiceDone() {
      return this.acceptedTerms && (this.currentInvoice.rows.length > 0) && (this.currentCompany !== undefined) &&
          this.selectedOccupation && this.currentInvoice.user.hasAllBankInfo &&
          this.currentInvoice.user.hasAllPersonalInfo;
    },
    isLoading() {
      return this.currentInvoice === undefined;
    },
    currentCompany() {
      if (this.currentInvoice.company) {
        return this.currentInvoice.company;
      }

      return this.companies.find((company) => company.id === this.selectedCompany);
    },
    netto() {
      return this.currentInvoice.rows.reduce((a, b) => parseFloat(a) + parseFloat(b.amount || 0), 0);
    },
    brutto() {
      return this.netto + this.vat;
    },
    vat() {
      return this.currentInvoice.rows.reduce((a, b) => {
        const carry = parseFloat(a);
        const amount = parseFloat(b.amount || 0);
        const vat = parseFloat(b.vat || 0);
        const current = this.getNetto(amount, vat);

        return carry + current;
      }, 0);
    },
    getUpdateRoute() {
      return `/invoices/${this.currentInvoice.id}/`;
    },
    purchaseOrder() {
      return this.currentInvoice !== undefined ? this.currentInvoice.purchase_order : '';
    },
    chargeFee() {
      return this.currentInvoice.user.charge_fee || 5.5;
    },
    requireAccept() {
      const icon = this.getRequiredIcon(!this.acceptedTerms);

      return `${icon} Accept terms`;
    },
    requirePersonalInfo() {
      const icon = this.getRequiredIcon(!this.currentInvoice.user.hasAllPersonalInfo);

      return `${icon} Personal info (settings)`;
    },
    requireBankInfo() {
      const icon = this.getRequiredIcon(!this.currentInvoice.user.hasAllBankInfo);

      return `${icon} Bank info (settings)`;
    },
    requireInfo() {
      const icon = this.getRequiredIcon(this.currentInvoice.rows.length < 1);

      return `${icon} Add invoice info`;
    },
    requireCompany() {
      const icon = this.getRequiredIcon(this.currentCompany === undefined);

      return `${icon} Select company`;
    },
    requireOccupation() {
      const icon = this.getRequiredIcon(!this.selectedOccupation);

      return `${icon} Select occupation`;
    },
  },
  watch: {
    selectedCompany(newValue, oldValue) {
      if (newValue) {
        this.updateCompany();
      }
    },
    selectedCurrency(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateInvoice();
      }
    },
    selectedOccupation(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateInvoice();
      }
    },
    useQuickPay(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateInvoice();
      }
    },
  },
  mounted() {
    this.prepareComponent();
  },
  methods: {
    prepareComponent() {
      $('body').tooltip({selector: '[data-toggle=tooltip]'});
      this.getCompanies();
      if (this.invoice !== undefined) {
        this.setInvoice(this.invoice, true);
        this.loaded = true;
        return;
      }
      // Store a new empty invoice for current user. (Or get a empty existing)
      axios.get('/invoices/generate-new', {}, {
        headers: {
          'Content-Type': 'application/json',
          // 'X-CSRF-TOKEN': token.content,
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        this.setInvoice(response.data);
        this.loaded = true;
      });
    },
    setInvoice(invoice, updateQuickPay = false) {
      this.currentInvoice = invoice;
      if (this.currentInvoice.rows === undefined) {
        this.currentInvoice.rows = [];
      }
      if (this.currentInvoice.company_id !== undefined) {
        this.selectedCompany = this.currentInvoice.company_id;
      }
      this.tax = this.currentInvoice.tax;
      this.selectedCurrency = this.currentInvoice.currency;
      this.selectedOccupation = this.currentInvoice.occupation_id;
      if (updateQuickPay) {
        this.useQuickPay = !!this.currentInvoice.quick_pay;
      }
    },
    getCompanies() {
      axios.get('/companies', {}, {
        headers: {
          'Content-Type': 'application/json',
          // 'X-CSRF-TOKEN': token.content,
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        this.companies = response.data;
      });
    },
    editInvoiceRow(row) {
      this.invoiceRow = row;
      $('#invoiceRowModal').modal('show');
    },
    newInvoiceRow() {
      this.invoiceRow = undefined;
      $('#invoiceRowModal').modal('show');
    },
    onInvoiceRowChange(row) {

      let found = false;
      this.currentInvoice.rows.forEach((element, index) => {
        if (element.id === row.id) {
          this.$set(this.currentInvoice.rows, index, row);
          found = true;
          return;
        }
      });

      if (found) {
        return this.closeInvoiceRowModal('Invoice info updated.');
      }

      this.currentInvoice.rows.push(row);
      this.closeInvoiceRowModal('Invoice info added.');
    },
    closeInvoiceRowModal(message) {
      $('#invoiceRowModal').modal('hide');
      this.$toasted.success(message);
    },

    sendInvoice() {
      const data = {};

      let form = document.createElement('form');
      form.setAttribute('method', 'get');
      form.setAttribute('action', '/invoices/' + this.currentInvoice.id + '/send');

      let csrf = document.createElement('input');
      csrf.setAttribute('type', 'hidden');
      csrf.setAttribute('name', '_token');
      csrf.setAttribute('value', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
      form.appendChild(csrf);

      for (const [key, value] of Object.entries(data)) {
        let field = document.createElement('input');
        field.setAttribute('type', 'hidden');
        field.setAttribute('name', key);
        field.setAttribute('value', value);
        form.appendChild(field);
      }
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    removeInvoiceRow(row) {
      axios.delete('/invoices/' + this.currentInvoice.id + '/rows/' + row.id).then(response => {
        this.currentInvoice = response.data;
      });
    },
    updateCompany() {
      //TODO: Notify user on the store before?
      axios.patch('/invoices/' + this.currentInvoice.id, {company_id: this.selectedCompany}, {
        headers: {
          'Content-Type': 'application/json',
          // 'X-CSRF-TOKEN': token.content,
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        this.setInvoice(response.data);
      });
    },
    updateInvoice() {
      if (!this.loaded) {
        return;
      }

      let data = {};
      if (this.currentInvoice.currency !== this.selectedCurrency) {
        data['currency'] = this.selectedCurrency;
      }
      if (this.currentInvoice.occupation_id !== this.selectedOccupation) {
        data['occupation_id'] = this.selectedOccupation;
      }
      if ((!!this.currentInvoice.quick_pay) !== this.useQuickPay) {
        data['quick_pay'] = this.useQuickPay ? 1 : 0;
      }
      if (isEmpty(data)) {
        return;
      }
      this.updating = true;
      let id = ++this.updateQueueId;
      axios.patch('/invoices/' + this.currentInvoice.id, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        // Just a quick fix for a rare bug were an older update call would replace new data with old data.
        if (this.updateQueueId === id) {
          this.setInvoice(response.data);
        }
      }).finally(() => {
        this.updating = false;
      });
    },
    getNetto(amount, vat) {
      return amount * (vat / 100);
    },
    percent(value) {
      return (100 - value) / 100;
    },
    rowCount(row) {
      const count = row.count;
      const units = row.units;
      if (units) {
        const slug = units.slug || '';
        const unit = window.Lang.get(`units.${row.units.slug}`);

        return `${count} ${unit}`;
      }

      return count;
    },
    getRequiredIcon(unchecked) {
      let name = 'checkbox-outline';
      if (unchecked) {
        name = 'square-outline';
      }

      return `<ion-icon name="${name}" class="md-hydrated align-middle mr-1"></ion-icon>`;
    },
    companyUpdated(company) {
      const index = this.companies.findIndex(p => p.id === company.id);
      if (index !== -1) {
        this.companies.splice(index, 1, company);
        this.currentInvoice.company = company;
      } else {
        this.companies.push(company);
      }
      this.selectedCompany = company.id;
      $(this.$refs.companyModal.$el).modal('hide');
    },
    showCompanyModal(id) {
      const company = this.companies.find(company => company.id === id);
      this.editCompany = company || {};
      $(this.$refs.companyModal.$el).modal('show');
    },
  }, components: {
    ModelListSelect,
  },
};
</script>

<style lang="scss">

</style>
